(() => {
  function resolve(mapping, variantId, quantity) {
    if (String(variantId) !== String(mapping.packId)) return null;
    const count = Number(quantity);
    if (!Number.isSafeInteger(count) || count < 1 || count > 125 || !mapping.singleAvailable) throw new Error(mapping.strings.unavailable);
    const units = count * 4;
    if (mapping.inventory !== null && units > mapping.inventory) throw new Error(mapping.strings.unavailable);
    return {id: String(mapping.singleId), quantity: units};
  }
  if (typeof module !== 'undefined') module.exports = {resolve};
  if (typeof document === 'undefined') return;
  const mappings = new Map();
  function discover() {
    document.querySelectorAll('[data-bp-four-pack-config]').forEach(script => {
      if (script.dataset.bpRead) return;
      const mapping = JSON.parse(script.textContent);
      mappings.set(String(mapping.packId), mapping);
      script.dataset.bpRead = 'true';
    });
  }
  function selected(form) {
    discover();
    const id = form.querySelector('[name="id"]')?.value;
    return mappings.get(String(id));
  }
  function prepareForm(form) {
    const mapping = selected(form);
    if (!mapping || form.querySelector('[name="selling_plan"]')?.value) return null;
    const plan = resolve(mapping, form.querySelector('[name="id"]').value, form.querySelector('[name="quantity"]')?.value || '1');
    const data = new FormData(form);
    data.set('id', plan.id);
    data.set('quantity', String(plan.quantity));
    return data;
  }
  window.BPFourPacks = {prepareForm};
  document.addEventListener('formdata', event => {
    const mapping = selected(event.target);
    if (!mapping || event.formData.get('selling_plan')) return;
    if (String(event.formData.get('id')) === String(mapping.singleId)) return;
    try {
      const plan = resolve(mapping, event.formData.get('id'), event.formData.get('quantity') || '1');
      if (plan) {
        event.formData.set('id', plan.id);
        event.formData.set('quantity', String(plan.quantity));
      }
    } catch {
      event.formData.set('quantity', '0');
    }
  });
  document.addEventListener('submit', event => {
    try {
      const mapping = selected(event.target);
      if (mapping) resolve(mapping, event.target.querySelector('[name="id"]').value, event.target.querySelector('[name="quantity"]')?.value || '1');
    } catch (error) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const note = event.target.querySelector('[data-bp-pack-note]');
      if (note) {note.textContent = error.message; note.setAttribute('role', 'alert');}
    }
  }, true);
  function refresh() {
    discover();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (!form.querySelector('[type="submit"]')) return;
      const mapping = selected(form);
      const payment = form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = !!mapping;
      let note = form.querySelector('[data-bp-pack-note]');
      if (!mapping) {
        if (note) note.hidden = true;
        const single = [...mappings.values()].find(m => String(m.singleId) === String(form.querySelector('[name="id"]')?.value));
        const adjuster = form.querySelector('.qty-adjuster');
        if (single && adjuster) {
          if(single.inventory === null) delete adjuster.dataset.limit;
          else adjuster.dataset.limit = String(single.inventory);
        }
        return;
      }
      if (!note) {
        note = document.createElement('p');
        note.dataset.bpPackNote = '';
        note.className = 'bp-pack-note';
        note.setAttribute('aria-live', 'polite');
        form.append(note);
      }
      note.hidden = false;
      const count = Number(form.querySelector('[name="quantity"]')?.value || '1');
      const units = Number.isSafeInteger(count) && count > 0 ? count * 4 : 4;
      let text = (mapping.pairs ? mapping.strings.eye_quantity : mapping.strings.quantity).replace('[units]', String(units)).replace('[pairs]', String(units * mapping.pairs)).replace('[packs]', String(units / 4));
      try {resolve(mapping,mapping.packId,count);note.removeAttribute('role');} catch(error) {text=error.message;note.setAttribute('role','alert');}
      if (note.textContent !== text) note.textContent = text;
      const adjuster = form.querySelector('.qty-adjuster');
      if (adjuster && mapping.inventory !== null) adjuster.dataset.limit = String(Math.floor(mapping.inventory / 4));
    });
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false; refresh();});
  }
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('click', schedule);
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  refresh();
})();
